import Footer from "../admin/components/footer";
import Header from "../admin/components/header";

const AdminLayout = ({ children }) => {

  return (<>
    <div className="DashboardMainBody">
      <Header />
      {children}
    </div>
    <Footer menuName={children?.props?.menuName} />
  </>);
}

export default AdminLayout;